import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { withRouter } from 'react-router';
import styled from 'styled-components';
import BlockUi from 'react-block-ui';
import DetailsContainer from '../details/DetailsContainer';
import { errorRoutes } from '../routes/error/errorRoutes.ts';
import routes from '../routes/routes.ts';
import ErrorPage from './common/components/ErrorPage.tsx';
import NotificationsListContainer from './common/notifications/NotificationsListContainer.ts';
import 'react-block-ui/style.css';
import HomePageContainer from '../home/HomePageContainer.ts';
import { injectIntl } from 'react-intl';
import { TranslationHelpers } from '../i18n/translationHelpers';
import PageWithTitle from '../app/PageWithTitle';
import pathMapping from './ratPageView';
import { RegionHelper } from '../utils/RegionHelper';
import Cookie from '../policy/Cookie';
import PointsTermsOfUse from '../policy/PointsTermsOfUse';
import CookieManager from '../policy/CookieManager';
import About from '../about';

const Wrapper = styled.div`
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    ${(props) =>
        props.loading
            ? 'justify-content: center; align-items: center;'
            : 'justify-content: space-between;'};

    .block-ui-overlay {
        background: #000000;
        opacity: 0.7;
    }

    .loading-indicator {
        display: none;
    }
`;

const EU_STATIC_PAGES_ROUTES_MAP = [
    { path: '/cookie-policy', component: Cookie },
    { path: '/points-terms-of-use', component: PointsTermsOfUse },
    { path: '/cookie-manager', component: CookieManager },
    { path: '/about', component: About },
];

class App extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            pageName: '',
            siteSection: '',
            isMemberLoggedIn: Object.keys(this.props.member).length,
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const currentPath = nextProps.location.pathname;
        const newState = pathMapping[currentPath] || { name: '404', section: 'n/a' };
        if (newState.name !== prevState.pageName || newState.section !== prevState.siteSection) {
            return {
                pageName: newState.name,
                siteSection: newState.section,
            };
        }
        return null;
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            document.dispatchEvent(new Event('SINGLE_PAGE_APPLICATION_LOAD'));
        }
    }

    render() {
        const {
            blockUI,
            appConfig,
            intl,
            member: { hasEKYC },
        } = this.props;

        const homePageTitle = intl.formatMessage(
            TranslationHelpers.getMessageDescriptor('top.title'),
        );
        return (
            <Wrapper loading={this.props.redirect}>
                <React.Fragment>
                    <NotificationsListContainer />
                    <BlockUi blocking={blockUI} color="#000000">
                        <Switch>
                            {errorRoutes.map((route) => (
                                <Route
                                    path={route.path}
                                    key={route.id}
                                    render={() => <ErrorPage contentId={route.contentId} />}
                                />
                            ))}
                            <Route
                                exact
                                path="/"
                                render={() => (
                                    <PageWithTitle title={homePageTitle}>
                                        <HomePageContainer />
                                    </PageWithTitle>
                                )}
                            />
                            {RegionHelper.isEU() &&
                                EU_STATIC_PAGES_ROUTES_MAP.map(({ path, component }, index) => (
                                    <Route key={index} path={path} component={component} />
                                ))}
                            {routes.map((route) => (
                                <Route
                                    path={route.path}
                                    key={route.id}
                                    component={DetailsContainer}
                                />
                            ))}
                            <Route render={() => <ErrorPage contentId="p404" />} />
                        </Switch>
                    </BlockUi>
                </React.Fragment>
                <input
                    type="hidden"
                    name="rat"
                    id="ratAccountId"
                    value={appConfig.RAT_ACCOUNT_ID}
                />
                <input
                    type="hidden"
                    name="rat"
                    id="ratServiceId"
                    value={appConfig.RAT_SERVICE_ID}
                />
                <input type="hidden" name="rat" id="ratPageLayout" value="pc" />
                <input
                    type="hidden"
                    name="rat"
                    id="ratSiteSection"
                    value={this.state.siteSection}
                />
                {this.state.pageName && (
                    <input type="hidden" name="rat" id="ratPageName" value={this.state.pageName} />
                )}
            </Wrapper>
        );
    }
}

const AppWithRouter = withRouter(App);
export default injectIntl(AppWithRouter);
